import { get, post, put, destroy } from "presentation/utils/api";

//Define a rota base desse serviço
const baseRoute = "DisciplinesEmployees";


export const findAll = async () => {
    return await get(baseRoute);
};

export const findById = async (id) => {
    return await get(baseRoute, "/" + id);
};

export const add = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "", data);
};

export const batchAdd = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "batch_add", data);
};

export const update = async (postData) => {
    var data = JSON.stringify(postData);
    return await put(baseRoute, "", data);
};

export const save = async (postData) => {
    if (postData.id !== undefined) {
        return await update(postData);
    } else {
        return await add(postData);
    }
};

export const remove = async (id) => {
    return await destroy(baseRoute, "", id);
};

export const employeeDisciplines = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "emplyee_disciplines", data);
};

export const search = async (postData) => {
    var data = JSON.stringify(postData);
    return await post(baseRoute, "search", data);
};


const disciplinesEmployeesService = {
    findAll,
    findById,
    batchAdd,
    add,
    update,
    save,
    remove,
    search,
    employeeDisciplines
}

export default disciplinesEmployeesService;